import React from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Page Not Found | Cloudare</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
      <main
        style={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "80px 24px",
        }}
      >
        <h1 style={{ fontSize: "5rem", margin: 0, color: "#6366f1" }}>404</h1>
        <h2 style={{ marginTop: 8 }}>We couldn't find that page</h2>
        <p style={{ maxWidth: 520, color: "#475569" }}>
          The page you're looking for may have moved or no longer exists. Let's
          get you back on track.
        </p>
        <div style={{ display: "flex", gap: 16, marginTop: 24, flexWrap: "wrap", justifyContent: "center" }}>
          <NavLink
            to="/"
            style={{
              background: "#6366f1",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Back to Home
          </NavLink>
          <NavLink
            to="/contact-us"
            style={{
              border: "1px solid #6366f1",
              color: "#6366f1",
              padding: "12px 24px",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Contact Us
          </NavLink>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
}
